// extracted by mini-css-extract-plugin
export default {"start-page-body":"focus-import_start-page-body__65g0V","import-input-wrapper":"focus-import_import-input-wrapper__lPYsQ"};